/**
 * 角色管理
 */
import { ROLEMANAGE } from '../types';

export default {
    name: `${ROLEMANAGE}`,
    path: '/roleManage',
    component: () => import(/* webpackChunkName: 'roleManage' */ '@/views/roleManage/'),
    redirect: { name: `${ROLEMANAGE}Index` },
    meta: {
        title: '角色管理',
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${ROLEMANAGE}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'roleManage' */ '@/views/roleManage/home/Home.vue'),
        },
    ],
};
